import "./DigitalPresenceConsultation.module.css";
import Header from "@/reusable_sections/Header";
import HeroDelCatalogo from "./sections/HeroDelCatalogo";
import BenefitsOfLearning from "./sections/BenefitsOfLearning";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function DigitalPresenceConsultationPage() {
  return <div>
      <Header />
      <HeroDelCatalogo />
      <BenefitsOfLearning />
      <CallToAction />
      <Footer />
    </div>;
}